<script lang="ts">
  import { mdiRobotOutline, mdiHandBackRightOutline, mdiCalendarCheck } from "@mdi/js"
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import type { AppointmentPlanningStrategy } from "../../../../../../../../../../../api/kehrblatt/planning"
  import type {
    PlanningPreviewRow,
    PlanningPreviewRowChange,
  } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    row: PlanningPreviewRow
    disabled?: boolean
    onChange: (row: PlanningPreviewRow, change: PlanningPreviewRowChange) => void
  }

  const { row, disabled = false, onChange }: Props = $props()

  const strategyShortLabel = (value: AppointmentPlanningStrategy): string => {
    if (value === "MANUAL") return "Manuell"

    if (value === "KEEP_EXISTING") return "Übernehmen"

    return "Automatisch"
  }

  const strategyAriaLabel = (value: AppointmentPlanningStrategy): string => {
    if (value === "MANUAL") return "Manuell planen"

    if (value === "KEEP_EXISTING") return "Bestehenden Termin übernehmen"

    return "Automatisch planen"
  }

  const strategyTooltip = (value: AppointmentPlanningStrategy): string => {
    if (value === "MANUAL") return "Manuell: Termin wird manuell gesetzt."

    if (value === "KEEP_EXISTING") return "Übernehmen: bestehender Auftragstermin wird behalten."

    return "Automatisch: KehrBlatt plant den Termin neu."
  }

  const readValue = (value: string): AppointmentPlanningStrategy =>
    value === "MANUAL" || value === "KEEP_EXISTING" ? value : "AUTO"

  const toggleOptions = $derived(
    row.planningStrategyOptions.map((option) => {
      const value = readValue(option.value)

      return {
        value,
        label: strategyShortLabel(value),
        icon:
          value === "MANUAL"
            ? mdiHandBackRightOutline
            : value === "KEEP_EXISTING"
              ? mdiCalendarCheck
              : mdiRobotOutline,
        ariaLabel: strategyAriaLabel(value),
        tooltipContent: strategyTooltip(value),
      }
    }),
  )
</script>

<div class="strategy-toggle-cell" aria-label="Terminierung">
  <ToggleCTA
    options={toggleOptions}
    value={row.planningStrategy}
    small={true}
    darkMode={false}
    {disabled}
    onChange={(value) => onChange(row, { kind: "planning_strategy", value: readValue(value) })}
  />
</div>

<style lang="less">
  .strategy-toggle-cell {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
  }

  .strategy-toggle-cell :global(button.cta.toggle) {
    min-width: 2rem;
    padding-inline: 0.45rem;
  }
</style>
